lmApp
  .directive('lmApplicationAndroid', [
    function () {
      return {
        templateUrl: 'lm-showcase/application-android/application-android.tpl.html',
        restrict: 'E',
        replace: true,
        scope: {
          applications: '=?',
          tab: '=?'
        },
        controller: ['$scope', '$rootScope', '$interval', '$templateCache', '$compile', '$q', '$timeout', 'ShowcaseService', 'GroupService', 'ModalWindowService', 'ToastService', 'ApplicationService', 'ModalConfirmService',
          function ($scope, $rootScope, $interval, $templateCache, $compile, $q, $timeout, ShowcaseService, GroupService, ModalWindowService, ToastService, ApplicationService, ModalConfirmService) {
            $scope.permissions = $rootScope.permissions;
            $scope.namespace = 'stockmob';
            $scope.showVariants = true;
            $scope.application = {};
            $scope.application.currentShowcase = {};
            $scope.application.currentScreen = {};
            $scope.screensCollection = [];
            $scope.showcasesCollection = [];
            $scope.availableGroups = [];

            var _parseShowcase = function (showcase) {
              if (!showcase._PrivateData) showcase._PrivateData = {};

              showcase._PrivateData.groups = $scope.availableGroups
                .filter(function (group) {
                  return _.includes(showcase.group_id, group.id);
                });

              return showcase;
            };

            ShowcaseService.GetScreens($scope.applications.platform.id)
              .then(function (screensCollection) {
                $scope.screensCollection = screensCollection;

                if (screensCollection.length) {
                  $scope.application.currentScreen = $scope.screensCollection[0];
                }
              });

            $scope.toggleVariants = function () {
              $scope.showVariants = !$scope.showVariants;
            };

            $scope.isSuperuser = function () {
              return $rootScope.isSuperuser();
            };

            $scope.changePriority = function (showcase, index, isDown) {
              index = index + (isDown ? 1 : index ? -1 : 0);
              showcase.priority = $scope.showcasesCollection[index].priority + (isDown ? -1 : 1);

              $scope.updateShowcase(showcase, index);
              $scope.showcasesCollection = _.orderBy($scope.showcasesCollection, ['priority'], ['desc']);
            };

            $scope.setShowcase = function (showcase) {
              $scope.application.currentShowcase = showcase;
            };

            $scope.createNewScreen = function () {
              $scope.newScreen = {
                title: ''
              };

              $scope._tpl_ = $templateCache.get('add-screen.html');

              $scope._tpl_ = $compile($scope._tpl_)($scope);

              ModalWindowService.Open({
                content: $scope._tpl_,
                size: {
                  s: 4
                },
                actions: [
                  {
                    title: 'create',
                    color: 'lm',
                    fn: function () {
                      if (!$scope.newScreen.title) $scope.newScreen.title = 'Showcase #' + Date.now();

                      $scope.loading = true;
                      $rootScope.showLinearProgress('#appLoader');

                      ShowcaseService.CreateScreen($scope.newScreen, $scope.applications.platform.id)
                        .then(function (response) {
                          ToastService.Small({
                            title: 'Screen successfully created',
                            color: 'green',
                            icon: 'view-dashboard'
                          }, 1000 * 3);
                          $scope.loading = false;
                          $rootScope.hideLinearProgress('#appLoader');
                          $scope.newScreen.title = '';
                          $scope.screensCollection.push(response.showcase.screen);
                          $scope.application.currentScreen = response.showcase.screen;
                        })
                        .catch(function (reason) {
                          $rootScope.debugInfo(reason);
                          $scope.loading = false;
                          $rootScope.hideLinearProgress('#appLoader');
                        })
                    }
                  },
                  {
                    title: 'Cancel',
                    color: 'grey  '
                  }
                ]
              });
            };

            $scope.createNewVariant = function (showcase) {
              $scope.newShowcase = {
                title: '',
                groups: []
              };

              $scope._tpl_ = $templateCache.get('add-screen-variant.html');

              $scope._tpl_ = $compile($scope._tpl_)($scope);

              ModalWindowService.Open({
                content: $scope._tpl_,
                size: {
                  s: 4
                },
                actions: [
                  {
                    title: 'Create',
                    color: 'lm',
                    fn: function () {
                      if (!$scope.newShowcase.title) $scope.newShowcase.title = 'Showcase #' + Date.now();

                      $scope.loading = true;
                      $rootScope.showLinearProgress('#appLoader');

                      $scope.newShowcase.priority = (_.last($scope.showcasesCollection) ? _.last($scope.showcasesCollection).priority : 0) - 10;
                      $scope.newShowcase.group_id = _.map($scope.newShowcase.groups, 'id');

                      ShowcaseService.CreateScreenVariant(
                        $scope.newShowcase,
                        $scope.applications.platform.id,
                        $scope.application.currentScreen)
                        .then(function (response) {
                          ToastService.Small({
                            title: 'Showcase successfully created',
                            color: 'green',
                            icon: 'view-dashboard'
                          }, 1000 * 3);
                          $scope.loading = false;
                          $rootScope.hideLinearProgress('#appLoader');
                          $scope.newShowcase.title = '';
                          $scope.showcasesCollection.push(response.showcase);
                          $scope.application.currentShowcase = response.showcase;
                        })
                        .catch(function (reason) {
                          $rootScope.debugInfo(reason);
                          $scope.loading = false;
                          $rootScope.hideLinearProgress('#appLoader');
                        })
                    }
                  },
                  {
                    title: 'Cancel',
                    color: 'grey  '
                  }
                ]
              });
            };

            $scope.updateShowcase = function (showcase, index) {
              $scope.loading = true;
              $rootScope.showLinearProgress('#appLoader');

              var tmpShowcase = _.cloneDeepWith(showcase);

              tmpShowcase.group_id = _.map(showcase._PrivateData.groups, 'id');

              ShowcaseService.UpdateShowcase(tmpShowcase)
                .then(function (response) {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#appLoader');
                  ToastService.Small({
                    title: 'Showcase successfully updated',
                    color: 'green',
                    icon: 'view-dashboard'
                  }, 1000 * 3);
                  $scope.showcasesCollection[index] = _parseShowcase(response.showcase);
                })
                .catch(function (reason) {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#appLoader');

                  if (reason.message === 'everyone left without showcases') {
                    ToastService.Big({
                      title: 'Warning',
                      text: 'You can\'t leave screen without default variant. First set "Everyone" group to another representation.',
                      color: 'amber',
                      icon: 'view-dashboard'
                    }, 1000 * 30);

                    showcase._PrivateData.groups = $scope.availableGroups
                      .filter(function (group) {
                        return _.includes(showcase.group_id, group.id);
                      });
                  } else {
                    $rootScope.debugInfo(reason);
                    ToastService.Small({
                      title: 'Showcase update failed',
                      color: 'red',
                      icon: 'view-dashboard'
                    }, 1000 * 30);
                  }
                });
            };

            $scope.updateShowcaseLayout = function (showcase) {
              var diff = showcase._Grid.filter(function (tile) {
                return tile._PrivateData.isMoved;
              });

              if (diff.length) {
                $scope.loading = true;
                $rootScope.showLinearProgress('#appLoader');

                var allQ = [];

                diff.forEach(function (tile) {
                  allQ.push(ShowcaseService.UpdateTilePosition(tile));
                });

                $q.all(allQ)
                  .then(function (response) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#appLoader');
                    ToastService.Small({
                      title: 'Showcase layout successfully updated',
                      color: 'green',
                      icon: 'view-dashboard'
                    }, 1000 * 3);
                    $rootScope.$broadcast($rootScope.EVENTS.UPDATE_SHOWCASE_COLLECTION, showcase);
                    showcase._PrivateData.isLayoutChanged = false;
                  })
                  .catch(function (reason) {
                    $rootScope.debugInfo(reason);
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#appLoader');
                    ToastService.Small({
                      title: 'Showcase layout update failed',
                      color: 'red',
                      icon: 'view-dashboard'
                    }, 1000 * 3);
                  })
              } else {
                showcase._PrivateData.isLayoutChanged = false;
              }
            };

            $scope.deleteShowcase = function (showcase) {

              ModalConfirmService.Open({
                content: '<p class="fs-headline tc-red-800"> Delete </p> <p class="fs-title">This action will delete showcase permanently. ' +
                'Are You sure? </p>',
                action: {
                  title: 'Delete',
                  fn: function () {
                    $scope.loading = true;
                    $rootScope.showLinearProgress('#appLoader');

                    ShowcaseService.RemoveShowcase(showcase)
                      .then(function (response) {
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#appLoader');
                        ToastService.Small({
                          title: 'Showcase successfully removed',
                          color: 'green',
                          icon: 'view-dashboard'
                        }, 1000 * 3);

                        var index = $scope.showcasesCollection.indexOf(showcase);

                        if (index !== -1) $scope.showcasesCollection.splice(index, 1);
                      })
                      .catch(function (reason) {
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#appLoader');

                        if (reason.message === 'everyone left without showcases') {
                          ToastService.Big({
                            title: 'Warning',
                            text: 'You can\'t remove default variant. First set "everyone" group to another showcase.',
                            color: 'amber',
                            icon: 'view-dashboard'
                          }, 1000 * 30);
                        } else {
                          $rootScope.debugInfo(reason);
                          ToastService.Small({
                            title: 'Showcase removed failed',
                            color: 'red',
                            icon: 'view-dashboard'
                          }, 1000 * 3);
                        }
                      });
                  }
                }
              });
            };

            $scope.changeAppUrl = function (url) {
              ApplicationService.UpdatePlatform({app_url: url, id: $scope.applications.platform.id})
                .then(function (response) {
                  $rootScope.hideLinearProgress('#appLoader');
                  ToastService.Small({
                    title: 'App URL successfully changed',
                    color: 'green',
                    icon: 'dns'
                  });
                })
                .catch(function (reason) {
                  $rootScope.hideLinearProgress('#appLoader');
                  ToastService.Small({
                    title: 'App URL change failed',
                    color: 'red',
                    icon: 'dns'
                  });
                  $rootScope.debugInfo(reason);
                });
            };

            $scope.screenWatcher = $scope.$watch('application.currentScreen.id', function (newValue, oldValue) {
              if (newValue) ShowcaseService.GetShowcasesByScreenId(newValue)
                .then(function (showcaseCollection) {
                  if (showcaseCollection)
                    $scope.showcasesCollection = _.orderBy(showcaseCollection, ['priority'], ['desc']);

                  $scope.application.currentShowcase = _parseShowcase(showcaseCollection[0]);
                })
            });

            $scope.showcaseWatcher = $scope.$watch('application.currentShowcase.id', function (newValue, oldValue) {
              GroupService.GetGroups()
                .then(function (collection) {
                  $scope.availableGroups = collection
                    .map(function (group) {
                      return {
                        title: group.name,
                        id: group.id
                      }
                    });

                  $scope.showcasesCollection.forEach(_parseShowcase);
                })
                .catch(function (reason) {
                  $rootScope.hideLinearProgress('#activePackageLoader');
                  $rootScope.debugInfo(reason, 'silent');
                  ToastService.Small({
                    title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                    color: 'amber',
                    icon: 'server-off',
                    blocked: true
                  }, 1000 * 3);
                });
            });

            $scope.appWatcher = $scope.$watchCollection('applications.platform', function (newValue, oldValue) {

              ShowcaseService.GetScreens(newValue.id)
                .then(function (screensCollection) {
                  $scope.screensCollection = screensCollection;

                  if (screensCollection.length) {
                    $scope.application.currentScreen = $scope.screensCollection[0];

                    ShowcaseService.GetShowcasesByScreenId($scope.application.currentScreen.id)
                      .then(function (showcaseCollection) {
                        $scope.showcasesCollection = _.orderBy(showcaseCollection, ['priority'], ['desc']);

                        $scope.application.currentShowcase = _parseShowcase(showcaseCollection[0]);

                        GroupService.GetGroups()
                          .then(function (collection) {
                            $scope.availableGroups = collection
                              .map(function (group) {
                                return {
                                  title: group.name,
                                  id: group.id
                                }
                              });

                            $scope.showcasesCollection.forEach(_parseShowcase);
                          })
                          .catch(function (reason) {
                            $rootScope.hideLinearProgress('#activePackageLoader');
                            $rootScope.debugInfo(reason, 'silent');
                            ToastService.Small({
                              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                              color: 'amber',
                              icon: 'server-off',
                              blocked: true
                            }, 1000 * 3);
                          });
                      })
                  }
                });
            });


          }],
        link: function (scope, element) {
          element.on('$destroy', function () {
            if (scope.appWatcher) scope.appWatcher();
            if (scope.showcaseWatcher) scope.showcaseWatcher();
            if (scope.screenWatcher) scope.screenWatcher();
          });
        }
      }
    }
  ]);
